import Campaign from '@/classes/campaigns/Campaign'

export default class Campaigns extends Array {
  constructor (campaigns, ...rest) {
    Array.isArray(campaigns) ? super(...campaigns.map(campaign => new Campaign(campaign))) : super(...rest)
  }
}
